import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Checkbox,
  Grid,
  Typography,
  Container,
  FormControlLabel,
  FormControl,
  Radio,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import { useParams } from "react-router-dom";
import makeStyles from "@material-ui/styles/makeStyles";

import { styled } from '@mui/material/styles';
import RadioGroup, { useRadioGroup } from '@mui/material/RadioGroup';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { getPerkDataByUsername } from "../../../redux/actions/perk";
import { BOOKING_TYPE } from "../../../redux/types";

const BookingType = ({ activeStep, onhandleNext, onhandleBack, length, isPerk }) => {
  const dispatch = useDispatch();
  const [bookingType, setBookingType] = useState('Incall');
  const [valueAddPerkToBooking, setValueAddPerkToBooking] = useState('');
  const [meetRequirementForPerk, setMeetRequirementForPerk] = useState(false);

  const { bookFormId, bookFormTheme, welcomeTitle, welcomeMessage, bookingTypes, bookingData, perkData } = useSelector(state => ({
    bookFormId: state.book.emailNotification.bookFormId,
    bookFormTheme: state.book.emailNotification.bookFormTheme,
    welcomeTitle: state.book.emailNotification.welcomeTitle,
    welcomeMessage: state.book.emailNotification.welcomeMessage,
    bookingTypes: state.book.emailNotification.bookingTypes,
    bookingData: { bookingType: state.book.bookingType, perkTitle: state.book.perkTitle },
    perkData: state.perk.perkData
  }));

  const StyledFormControlLabel = styled((props) => <FormControlLabel {...props} />)(
    ({ theme, checked }) => ({
      backgroundColor: checked ? bookFormTheme ? '#f1faff' : '#212e48' : 'transparent',
      border: checked ? `1px dashed ${theme.palette.primary.main}` : '1px dashed #E4E6EF',
      borderRadius: '5px',
      maxWidth: '44%',
      marginRight: 0,
      marginBottom: '1rem',
      padding: '1rem',
      "&:hover": {
        backgroundColor: bookFormTheme ? '#f1faff' : '#212e48',
        border: `1px dashed ${theme.palette.primary.main}`,
      },
      "&:hover span svg": {
        color: '#009ef7',
      },
    }),
  );

  const useStyles = makeStyles({
    menuItem: {
      color: bookFormTheme ? '#5e6278' : '#92929f',
      padding: '9px 16px',
      fontSize: '13px',
      "&:hover": {
        color: '#009ef7',
        backgroundColor: bookFormTheme ? '#f1faff' : '#212e48',
      },
    },
    menuItemSelected: {
      color: '#fff',
      backgroundColor: '#009ef7 !important',
      alignItems: 'center',
      justifyContent: 'space-between',
      "&:hover": {
        color: '#fff',
        backgroundColor: '#009ef7 !important',
      },
    },
  });
  const styles = useStyles();

  const { username } = useParams();

  useEffect(() => {
    if (bookingData?.bookingType) {
      setBookingType(bookingData?.bookingType);
    }
    setValueAddPerkToBooking(bookingData?.perkTitle || '');
  }, [bookingData?.bookingType, bookingData?.perkTitle]);

  useEffect(() => {
    if (isPerk) {
      dispatch(getPerkDataByUsername(username));
    }
  }, []);

  function MyFormControlLabel(props) {
    const radioGroup = useRadioGroup();

    let checked = false;

    if (radioGroup) {
      checked = radioGroup.value === props.value;
    }
    return <StyledFormControlLabel checked={checked} {...props} />;
  }

  const handleChange = (event) => {
    setBookingType(event.target.value);
  }

  const handleClick = () => {
    if (isPerk && (meetRequirementForPerk === false || valueAddPerkToBooking === '')) {
      return;
    }
    const payload = { bookingType, bookFormId };
    if (isPerk) {
      payload.perkTitle = valueAddPerkToBooking;
    }
    dispatch({
      type: BOOKING_TYPE,
      payload: payload
    })
    onhandleNext();
  }

  const handleChangeAddPerkToBooking = (e) => {
    setValueAddPerkToBooking(e.target.value);
  }

  return (
    <Grid
      item
      display='flex'
      alignItems='center'
      justifyContent='center'
      sx={{ flexGrow: 1, flexDirection: 'column', paddingY: '5rem', backgroundColor: bookFormTheme ? '#fff' : '#151521' }}
    >
      <Container sx={{ maxWidth: { sm: '650px' } }}>
        <Grid>
          <Typography sx={{ fontSize: '1.4rem', fontWeight: 700, color: bookFormTheme ? '#3f4254' : '#fff', textAlign: { xs: 'center', md: 'left' } }}>{welcomeTitle}</Typography>
          <Typography
            sx={{
              fontSize: '0.92rem',
              fontWeight: 300,
              color: bookFormTheme ? '#666' : '#565674',
              mt: 1,
              textAlign: { xs: 'center', md: 'left' }
            }}>
            {welcomeMessage}
          </Typography>
        </Grid>
        <Grid sx={{ mt: 5 }}>
          <Typography sx={{ fontSize: '1.1rem', fontWeight: 700, color: bookFormTheme ? '#3f4254' : '#fff' }}>Booking Type</Typography>
        </Grid>
        <Grid sx={{ mt: 2.5 }}>
          <RadioGroup
            row
            // defaultValue={bookingType}
            value={bookingType}
            onChange={handleChange}>
            <Grid container spacing={2}>
              {bookingTypes?.incall &&
                <Grid item container xs={6}>
                  <MyFormControlLabel
                    value="Incall"
                    label={
                      <Grid>
                        <Typography sx={{ fontWeight: 600, fontSize: '0.98rem', color: bookFormTheme ? '#181c32' : '#fff', mb: 0.5 }}>Incall</Typography>
                        <Typography sx={{ fontWeight: 300, fontSize: '0.8rem', color: bookFormTheme ? '#777' : '#565674' }}>I will host at my hotel or residence.</Typography>
                      </Grid>
                    }
                    control={
                      <Radio
                        icon={<PermContactCalendarIcon sx={{ fontSize: '3rem' }} />}
                        checkedIcon={<PermContactCalendarIcon color="primary" sx={{ fontSize: '3rem' }} />}
                      />
                    }
                    sx={{ maxWidth: 'unset', ml: 0, mb: 0, p: { xs: 1, md: 2 } }}
                  />
                </Grid>
              }
              {bookingTypes?.outcall &&
                <Grid item container xs={6}>
                  <MyFormControlLabel
                    value="Outcall"
                    label={
                      <Grid>
                        <Typography sx={{ fontWeight: 600, fontSize: '0.98rem', color: bookFormTheme ? '#181c32' : '#fff', mb: 0.5 }}>Outcall</Typography>
                        <Typography sx={{ fontWeight: 300, fontSize: '0.8rem', color: bookFormTheme ? '#777' : '#565674' }}>I will meet you at your hotel or residence.</Typography>
                      </Grid>
                    }
                    control={
                      <Radio
                        icon={<BusinessCenterIcon sx={{ fontSize: '3rem' }} />}
                        checkedIcon={<BusinessCenterIcon color="primary" sx={{ fontSize: '3rem' }} />}
                      />
                    }
                    sx={{ maxWidth: 'unset', ml: 0, mb: 0, p: { xs: 1, md: 2 } }}
                  />
                </Grid>
              }
              {bookingTypes?.fmty &&
                <Grid item container xs={6}>
                  <MyFormControlLabel
                    value="Fly Me To You"
                    label={
                      <Grid>
                        <Typography sx={{ fontWeight: 600, fontSize: '0.98rem', color: bookFormTheme ? '#181c32' : '#fff', mb: 0.5 }}>Fly Me To You</Typography>
                        <Typography sx={{ fontWeight: 300, fontSize: '0.8rem', color: bookFormTheme ? '#777' : '#565674' }}>Fly me to wherever you are in the world.</Typography>
                      </Grid>
                    }
                    control={
                      <Radio
                        icon={<BusinessCenterIcon sx={{ fontSize: '3rem' }} />}
                        checkedIcon={<BusinessCenterIcon color="primary" sx={{ fontSize: '3rem' }} />}
                      />
                    }
                    sx={{ maxWidth: 'unset', ml: 0, mb: 0, p: { xs: 1, md: 2 } }}
                  />
                </Grid>
              }
              {bookingTypes?.message &&
                <Grid item container xs={6}>
                  <MyFormControlLabel
                    value="Duos or Couples"
                    label={
                      <Grid>
                        <Typography sx={{ fontWeight: 600, fontSize: '0.98rem', color: bookFormTheme ? '#181c32' : '#fff', mb: 0.5 }}>Duos or Couples</Typography>
                        <Typography sx={{ fontWeight: 300, fontSize: '0.8rem', color: bookFormTheme ? '#777' : '#565674' }}>With my friends or your plus one.</Typography>
                      </Grid>
                    }
                    control={
                      <Radio
                        icon={<BusinessCenterIcon sx={{ fontSize: '3rem' }} />}
                        checkedIcon={<BusinessCenterIcon color="primary" sx={{ fontSize: '3rem' }} />}
                      />
                    }
                    sx={{ maxWidth: 'unset', ml: 0, mb: 0, p: { xs: 1, md: 2 } }}
                  />
                </Grid>
              }
              {bookingTypes?.virtual &&
                <Grid item container xs={6}>
                  <MyFormControlLabel
                    value="Virtual"
                    label={
                      <Grid>
                        <Typography sx={{ fontWeight: 600, fontSize: '0.98rem', color: bookFormTheme ? '#181c32' : '#fff', mb: 0.5 }}>Virtual</Typography>
                        <Typography sx={{ fontWeight: 300, fontSize: '0.8rem', color: bookFormTheme ? '#777' : '#565674' }}>Virtual companionship and other digital goodies.</Typography>
                      </Grid>
                    }
                    control={
                      <Radio
                        icon={<BusinessCenterIcon sx={{ fontSize: '3rem' }} />}
                        checkedIcon={<BusinessCenterIcon color="primary" sx={{ fontSize: '3rem' }} />}
                      />
                    }
                    sx={{ maxWidth: 'unset', ml: 0, mb: 0, p: { xs: 1, md: 2 } }}
                  />
                </Grid>
              }
              {bookingTypes?.social &&
                <Grid item container xs={6}>
                  <MyFormControlLabel
                    value="Social"
                    label={
                      <Grid>
                        <Typography sx={{ fontWeight: 600, fontSize: '0.98rem', color: bookFormTheme ? '#181c32' : '#fff', mb: 0.5 }}>Social</Typography>
                        <Typography sx={{ fontWeight: 300, fontSize: '0.8rem', color: bookFormTheme ? '#777' : '#565674' }}>A platonic date of social time only.</Typography>
                      </Grid>
                    }
                    control={
                      <Radio
                        icon={<BusinessCenterIcon sx={{ fontSize: '3rem' }} />}
                        checkedIcon={<BusinessCenterIcon color="primary" sx={{ fontSize: '3rem' }} />}
                      />
                    }
                    sx={{ maxWidth: 'unset', ml: 0, mb: 0, p: { xs: 1, md: 2 } }}
                  />
                </Grid>
              }
            </Grid>
          </RadioGroup>
        </Grid>
        {isPerk && (
          <Grid>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 400, mb: 1 }}>I would like to apply this Perk to my booking: <span style={{ color: 'red' }}>*</span></Typography>
              <Select
                inputProps={{ sx: { color: valueAddPerkToBooking ? '#5e6278' : '#b6b9c3', fontWeight: 600 } }}
                displayEmpty={true}
                value={valueAddPerkToBooking}
                renderValue={value => value ? value : 'Select ...'}
                sx={{ padding: 0, '.MuiSelect-select': { padding: '12px 20px' }, '.MuiOutlinedInput-notchedOutline': { borderStyle: 'none' } }}
                onChange={handleChangeAddPerkToBooking}
              >
                {perkData.map((perk, index) => (
                  <MenuItem key={index} value={perk.title} classes={{ root: styles.menuItem, selected: styles.menuItemSelected }}>{perk.title}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {valueAddPerkToBooking && (
              <FormControlLabel
                xs={4}
                value={meetRequirementForPerk}
                label={<Typography sx={{ fontWeight: 300, fontSize: '13px', color: bookFormTheme ? "#181c32" : "#fff" }}>
                  I've read and acknowledge I meet the requirements for this Perk.  <span style={{ color: 'red' }}>*</span>
                  </Typography>}
                control={<Checkbox checked={meetRequirementForPerk} />}
                onChange={e => setMeetRequirementForPerk(prev => !prev)}
              />
            )}
          </Grid>
        )}
      </Container>
      <Grid display='flex' justifyContent='space-between' sx={{ mt: 1.5, width: { md: '600px' } }}>
        <Button
          disabled={activeStep === 0}
          onClick={onhandleBack}
          sx={{ mt: 1, mr: 1, display: activeStep !== 0 ? 'flex' : 'none' }}
        >
          Back
        </Button>
        <Button
          variant="contained"
          onClick={handleClick}
          endIcon={<ArrowForwardIcon />}
          sx={{ mt: 1, mr: 1, color: '#fff', textTransform: 'none', fontWeight: 600 }}
        >
          {activeStep === length - 1 ? 'Finish' : 'Continue'}
        </Button>
      </Grid>
    </Grid>
  )
}

export default BookingType;
